import { render, staticRenderFns } from "./Checkpoint.vue?vue&type=template&id=6c089b7a"
import script from "./Checkpoint.vue?vue&type=script&lang=js"
export * from "./Checkpoint.vue?vue&type=script&lang=js"
import style0 from "./Checkpoint.vue?vue&type=style&index=0&id=6c089b7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports